var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPanPasteleria = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9224 3.07753C23.6179 5.77356 20.9829 11.1273 16.0553 16.0555C11.1277 20.9814 5.77343 23.6169 3.07796 20.922C0.38193 18.2259 3.01685 12.8722 7.94447 7.94404C12.8715 3.01753 18.2264 0.382064 20.9224 3.07753Z",
    fill: "#FFB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 14.7426C9.89503 17.0659 9.53393 18.3919 9.06172 19.1497C8.05342 20.0558 7.57732 20.158 7.57732 20.158C7.57732 20.158 7.41789 13.8437 7.59066 11.4444C7.60232 11.2822 8.36619 10.2522 8.36619 10.2522C8.36619 10.2522 9.55059 12.3427 9.72559 14.7426Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 11.0272C14.3394 13.3505 13.9777 14.6765 13.5061 15.4343C12.4978 16.3404 12.0217 16.4426 12.0217 16.4426C12.0217 16.4426 11.8623 10.1289 12.0345 7.72899C12.0461 7.56677 12.81 6.5368 12.81 6.5368C12.81 6.5368 13.9955 8.62785 14.17 11.0272Z",
    fill: "#FFA000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6264 7.5318C18.7958 9.85506 18.4342 11.1811 17.9625 11.9389C16.9542 12.845 16.4781 12.9472 16.4781 12.9472C16.4781 12.9472 16.3187 6.63349 16.4909 4.23357C16.5026 4.07135 17.2664 3.04138 17.2664 3.04138C17.2664 3.04138 18.4508 5.13243 18.6264 7.5318Z",
    fill: "#FFA000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 15.8015C8.66667 18.2076 7.57726 20.1581 7.57726 20.1581C7.57726 20.1581 6.4884 18.2076 6.4884 15.8015C6.4884 13.3955 7.57726 11.4445 7.57726 11.4445C7.57726 11.4445 8.66667 13.3955 8.66667 15.8015Z",
    fill: "#FFE082"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1187 12.0872C13.1187 14.4938 12.0298 16.4443 12.0298 16.4443C12.0298 16.4443 10.941 14.4938 10.9404 12.0872C10.9404 9.68176 12.0298 7.73071 12.0298 7.73071C12.0298 7.73071 13.1187 9.68176 13.1187 12.0872Z",
    fill: "#FFE082"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5553 8.579C17.5553 10.9856 16.4659 12.9361 16.4659 12.9361C16.4659 12.9361 15.377 10.9856 15.3765 8.579C15.3765 6.17352 16.4659 4.22247 16.4659 4.22247C16.4659 4.22247 17.5553 6.17352 17.5553 8.579Z",
    fill: "#FFE082"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPanPasteleria, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PanPasteleria.ba394367.svg";
export { ForwardRef as ReactComponent };